  class heroSlider {
    constructor(html) {
      this.html = document.querySelector(html) || document;

      this.speed = this.html?.dataset?.speed || 2000;

      this.carouselItems = qsa('.homeHero--item', this.html);
      this.bullets = qsa('.homeHero--itemCta', this.html);
      this.positionIndicator = qs('.homeHero__pos', this.html);
      this.carouselItemsIndicator = qsa('.homeHero--itemTitle', this.html);
      this.downArrow = qs('.icon-down-arrow', this.html);
      this.sliderMask = qs('.homeHero--content', this.html);
      this.slidersIndicators = qs('.homeHero--control', this.html);
      this.mediaIcons = qs('.homeHero--interactiveControl', this.html);
      [this.currentSlide] = this.carouselItems;
      [this.currentSlideIndicator] = this.carouselItemsIndicator;
      this.currentPos = 0;
      // touch movements variables
      this.longTouch = false;
      this.carouselVerticalScroll = false;
      this.sceneSize = qs('.homeHero--item', this.html).clientWidth;
      this.moveX = 0;
      this.HTMLNODE = qs('html');
      this.buttonLinks = qsa('.homeHero--ctaContainer a', this.html);
      this.playPauseBtn = qs('.homeHero--playBtn', this.html);
      this.modalVideoButton = qs('.homeHero .cta-button-popup-modal a', this.html);
      this.modalVideo = qs('.homeHero .cta-button-popup-modal .videocontainer.modal-video', this.html);
      this.closeModalVideo = qs('.homeHero .btn-close', this.html);
      this.wasPlayCarouselOnWhileShowingPopup = false;
      
      this.configSlider();
  
      $on(this.downArrow, 'click', this.scrollAfterHero.bind(this));
      $on(this.downArrow, 'touchstart', this.scrollAfterHero.bind(this));
    }
  
    configSlider() {
      if (this.carouselItems.length > 1) {
        // set the size for the carousel item selectors
        this.setDynamicClass(this.carouselItems.length);
        // set the size of the position indicator
        this.positionIndicatorSize();
        this.updateCurrentSlide(0);
        removeClass(this.html, 'homeHero-loading');
  
        // add event listeners
        forEach(this.carouselItemsIndicator, (item, index) => {
          $on(item, 'click', this.updateSliderEvent.bind(this));
          if (index === 0) {
            // Update first position of indicator
            this.movePositionIndicator(item.offsetLeft);
          }
        });
        // update on screen resize
        $on(window, 'resize', this.updatePositionResize.bind(this));
        // slide on mobile
        $on(this.sliderMask, 'touchstart', this.onTouchStart.bind(this));
        $on(this.sliderMask, 'touchmove', this.onTouchMove.bind(this));
        $on(this.sliderMask, 'touchend', this.onTouchEnd.bind(this));
        $on(this.playPauseBtn, 'click', this.manageControls.bind(this));
        $on(this.modalVideoButton, "click", this.stopCarouselOnVideo.bind(this));
        $on(this.closeModalVideo, "click", this.rerunPlayCarousel.bind(this));
  
        forEach(this.bullets, bullet => {
          $on(bullet, 'click', event => {
            this.goToSlide(+event.target.dataset.pos);
          });
        });
        // auto cycle
        this.setAutoSlide();
      } else {
        addClass(this.currentSlide, 'active');
        addClass(this.currentSlideIndicator.parentElement, 'active');
        if(this.mediaIcons)this.mediaIcons.style.display = "none";
        if(this.slidersIndicators) this.slidersIndicators.style.display = "none";
      }
    }
  
    setAutoSlide() {
      this.timerAutoSlide = setInterval(
        this.goToNextSlide.bind(this),
        this.speed,
      );
    }
  
    manageControls() {
      if (hasClass(this.playPauseBtn, 'icon-play-btn')) {
        this.playHero();
      } else {
        this.pauseHero();
      }
    }
  
    playHero() {
      this.setAutoSlide();
      removeClass(this.playPauseBtn, 'icon-play-btn');
      addClass(this.playPauseBtn, 'icon-pause-btn');
      removeClass(this.html, 'paused');
    }

    pauseHero() {
      clearInterval(this.timerAutoSlide);
      removeClass(this.playPauseBtn, 'icon-pause-btn');
      addClass(this.playPauseBtn, 'icon-play-btn');
      addClass(this.html, 'paused');
    }

    stopCarouselOnVideo() {
     if(this.modalVideo && hasClass(this.playPauseBtn, 'icon-pause-btn')){
        this.wasPlayCarouselOnWhileShowingPopup = true;
        this.pauseHero();
      }
    }

    rerunPlayCarousel(){
      if(this.wasPlayCarouselOnWhileShowingPopup){
        this.playHero();
        this.wasPlayCarouselOnWhileShowingPopup = false;
      }
    }
  
    /**
     * scroll down until the hero isn't visible
     * @return {void}
     */
    scrollAfterHero() {
      const POS =
        this.html.clientHeight +
        window.pageYOffset +
        this.html.getBoundingClientRect().top;
      scrollTo(POS, 300);
    }
  
    /**
     * move the indicator based on the current item
     * @param {Number} pos
     * @return {void}
     */
    movePositionIndicator(pos) {
      this.positionIndicator.style.left = `${pos}px`;
    }
  
    /**
     * Go to the next slide
     * @return {void}
     */
    goToNextSlide() {
      let nextItem = this.currentPos + 1;
  
      if (this.currentPos === this.carouselItems.length - 1) {
        nextItem = 0;
      }
      this.goToSlide(nextItem);
    }
  
    goToPrevSlide() {
      let nextItem = this.currentPos - 1;
  
      if (this.currentPos === 0) {
        nextItem = this.carouselItems.length - 1;
      }
      this.goToSlide(nextItem);
    }
  
    /**
     * Go to certain slide
     * @param {Number} num
     * @return {void}
     */
    goToSlide(num) {
      const CTA_LIST = qsa('.homeHero--itemCta', this.html);
      if (CTA_LIST[num]) {
        this.movePositionIndicator(CTA_LIST[num].offsetLeft);
        this.updateCurrentSlide(num);
      }
    }
  
    /**
     * Set as active the current slide and the indicator
     * @param {Numbet} num
     * @return {void}
     */
    updateCurrentSlide(num, clicked = false) {
      const nextItemWrapper = qs('.homeHero--itemWrapper', this.carouselItems[num]);
  
      // update slider indicator
      removeClass(this.currentSlideIndicator.parentElement, 'active');
      addClass(this.carouselItemsIndicator[num].parentElement, 'active');
      // update slider
      removeClass(this.currentSlide, 'active');
      addClass(this.carouselItems[num], 'active');
  
      this.currentPos = num;
      this.currentSlideIndicator = this.carouselItemsIndicator[num];
      this.currentSlide = this.carouselItems[num];
  
      if (clicked) {
        nextItemWrapper.setAttribute('tabindex', '0');
        nextItemWrapper.focus();
  
        setTimeout(() => {
          nextItemWrapper.setAttribute('tabindex', '-1');
        }, 0);
      }
    }
  
    /**
     * Update the current position when the user resize
     * the screen
     * @return {void}
     */
    updatePositionResize() {
      this.carouselItems = qsa('.homeHero--item', this.html);
      this.activeIndicator = qs('.homeHero--itemCta.active .homeHero--itemTitle',this.html);
      this.movePositionIndicator(this.activeIndicator.offsetLeft);
      this.positionIndicatorSize();
    }
  
    /**
     * Update the current slide
     * @param {HTMLEvent} event
     */
    updateSliderEvent(event) {
      const EL = event.target;
      const parentCTA = closest(EL, '.homeHero--itemCta');
      const position = parentCTA.dataset.pos;
      // remove the auto slide timer
      clearTimeout(this.timerAutoSlide);
      this.movePositionIndicator(EL.offsetLeft);
      this.updateCurrentSlide(parseInt(position, 10), event.type === 'click');
      // reinitialize the auto slide
      this.setAutoSlide();
  
      // remove auto slide interval, hold on the current slide
      this.pauseHero();
    }
  
    /**
     * calculate the current indicator size based on
     * the first item
     * @return {void}
     */
    positionIndicatorSize() {
      this.positionIndicator.style.width = `${qs('.homeHero--itemCta', this.html).clientWidth}px`;
    }
  
    /**
     * place the js to calculate the size of the item column
     * @param {Number} len
     */
    setDynamicClass(len) {
      let amountClass;
  
      switch (len) {
        case 2:
          amountClass = 'jsTwo';
          break;
        case 3:
          amountClass = 'jsThree';
          break;
        case 4:
          amountClass = 'jsFour';
          break;
        default:
          break;
      }
  
     addClass(this.html, amountClass);
    }
  
    /**
     * Init values on touch screen
     * @param  {Event} event
     * @return {void}
     */
    onTouchStart(event) {
      this.longTouch = false;
      // detect long touch
      this.touchTimer = setTimeout(() => {
        this.longTouch = true;
      }, 150);
      // reset moveX
      this.moveX = 0;
      this.touchstartX = event.touches[0].pageX;
  
      // prevent swipe vertical variables
      this.swipePosXStart = event.touches[0].clientX;
      this.swipePosYStart = event.touches[0].clientY;
  
      // remove the auto slide timer
      clearTimeout(this.timerAutoSlide);
    }
  
    /**
     * Calculate the move on the touch screen and move the slider with it
     * @param  {Event} event touch event
     * @return {void}
     */
    onTouchMove(event) {
      // Continuously return touch position.
      this.touchmoveX = event.touches[0].pageX;
  
      // prevent diagonal swipe from line 251 - 265
      const xDist = this.swipePosXStart - event.touches[0].clientX;
      const yDist = this.swipePosYStart - event.touches[0].clientY;
      const r = Math.atan2(yDist, xDist);
      const swipeAngle = Math.round((r * 180) / Math.PI);
      // when the touch move goes to the x axis the vertical scroll will be prevented
      if (swipeAngle >= 40 && swipeAngle <= 140) {
        this.carouselVerticalScroll = true;
      } else if (swipeAngle <= -40 && swipeAngle >= -140) {
        this.carouselVerticalScroll = true;
      }
  
      if (!this.carouselVerticalScroll) {
        event.preventDefault();
      }
  
      // Calculate distance to translate holder.
      this.moveX = this.touchstartX - this.touchmoveX;
    }
  
    /**
     * When touch ends review if need to go to the next/previous slide
     * @return {void}
     */
    onTouchEnd() {
      // Calculate the distance swiped.
      clearTimeout(this.touchTimer);
      this.carouselVerticalScroll = false;
      // Calculate the index.
      if (this.moveX > this.sceneSize / 5) {
        this.goToNextSlide();
      } else if (this.moveX < (this.sceneSize / 5) * -1) {
        this.goToPrevSlide();
      }
  
      this.longTouch = false;
      // restart the auto slide
      if (!hasClass(this.html, 'paused')) {
        this.setAutoSlide();
      }
    }
  }
  
  (function ($) {
    $(document).ready(function () {
      new heroSlider(".homeHero");
    });

  }(window.jQuery));



  (function ($) {
    $('body')
        .on('show.bs.modal', '.modal', onModalShow)
        .on('hide.bs.modal', onModalHide)
    var focusElement;
    var ytApiLoaded = false;
    function loadYouTubeAPI() {
    if (ytApiLoaded) return;
    ytApiLoaded = true;
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

// Append params like enablejsapi=1
    function appendIframeParams(ytIframe) {
    if (!ytIframe) return;

    const iframe = $(ytIframe);
    let src = iframe.attr('src');

    const params = [
        { param: 'enablejsapi', value: '1' },
        { param: 'rel', value: '0' },
        { param: 'modestbranding', value: '1' }
    ];

    for (let i = 0; i < params.length; i++) {
        if (!src.includes(`${params[i].param}=`)) {
        const queryParam = {};
        queryParam[params[i].param] = params[i].value;
        src = $.fn.urlUtil.mergeQuery(src, queryParam);
        }
    }

    iframe.attr('src', src);
    }

//  For Brightcove video
    // Check if videojs is loaded     
    function waitForBrightcove(callback) {
        if (typeof videojs !== "undefined") {
            callback();
        } else {
            setTimeout(function () {
                waitForBrightcove(callback);
            }, 500);
        }
    }

// Global array to keep track of player instances if needed
        const ytPlayers = new Map();

    function onModalShow(e) {
            $(".body-wrapper").attr("aria-hidden", "true");
            focusElement = document.activeElement;
            var modal = $(e.target);
            const modalId = modal.attr("id");
            console.log("Modal ID:", modalId);
            const $ctaBtn = $(`[data-bs-target="#${modalId}"]`).first();
            console.log("CTA Button:", $ctaBtn);
            const parentComponent = $ctaBtn.closest('.homeHero--ctaContainer');
        
   
            if ($ctaBtn.length === 0) {
                console.warn("No CTA found for modal:", modalId);
                return;
            }
            for (var i = 0; i < $('.modal.fade').length; i++) {
                if (focusElement.dataset.target !== modal.attr('id')) {
                    var ele = $('.modal.fade')[i];
                    ele.setAttribute("aria-hidden", "true");
                } else {
                    var ele1 = $('.modal.fade.show')[i];
                    ele1.setAttribute("aria-hidden", "false");
                }
            }
    
            if (!modal.is('[data-suppress-move="true"]')) {
                ensureModalIsFormChild(modal);
            }
    
            if (parentComponent.length === 0) {
              return;
            }
        /* For Youtube video */
        if (parentComponent.length > 0) {
            
        const ytIframe = modal.find('iframe[src*="youtube"]')[0];
    
        if (ytIframe) {
            appendIframeParams(ytIframe);
            const iframeId = ytIframe.id || `yt-iframe-${Date.now()}`;
            ytIframe.id = iframeId; // ensure it has an ID
    
            function createYTPlayerWhenReady() {
            const player = new YT.Player(ytIframe, {
                events: {
                'onStateChange': function (event) {
                    if (event.data === YT.PlayerState.PLAYING) {
                    console.log("YouTube video play detected.");
                    trackAnalytics($(ytIframe), player);
                    }
                }
                }
            });
    
            ytPlayers.set(iframeId, player);
            }
    
            // If API already loaded
            if (window.YT && window.YT.Player) {
            createYTPlayerWhenReady();
            } else {
            // If API not ready, queue it
            window.onYouTubeIframeAPIReady = function () {
                createYTPlayerWhenReady();
            };
            }
    
            loadYouTubeAPI(); // Load the script only once
        }
         /* For Youtube video */
         /* For Brightcove video */
        waitForBrightcove(initVideoEvents);
        function initVideoEvents() {
            modal.find(".video-js").each(function () {
                console.log("it is inside video");
                var videoElem = this;
                if (!$(videoElem).data("initialized")) {
                    var bcPlayer = videojs(videoElem);
                    var videoId = $(videoElem).attr("data-video-id") || "video-" + Math.random();
    
                    $(videoElem).data("initialized", true);
    
                    bcPlayer.ready(function () {
                        //  console.log("Brightcove Video Duration Found:", videoDurations[videoId]);
                        bindPlayerEvents(bcPlayer, videoId);
                    });
                }
            });
        }

        function bindPlayerEvents(player, videoId) {

            console.log("bindPlayerEvents");

            player.ready(function () {
                // console.log("Player " + videoId + " is ready, binding events...");
    
                player.on("play", function () {
                    //  console.log("Video " + videoId + " playing, pausing other videos...");
                    trackAnalytics(player, videoId);
                    // Pause carousel if the video is inside one
                });
            })
        }
     /* For Brightcove video */
        function trackAnalytics() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              "heroBannerInteraction": "heroBannerInteraction",
              heroBannerInteraction: "heroBannerInteraction",
                interactionType: "videoPlay",
                elementClicked: "video",
                heroBanner: {
                name: "homeHero",
                title: $(".homeHero--item.active .homeHero--title").text().trim(),
                index: $(".homeHero--control .homeHero--itemCta.active").index(),
                ctaText: "",
                destinationURL: "",
                }
            });
            console.log('Tracked YouTube videoPlay event');
        }
    }
}


    function onModalHide(e) {
        if (!$(document.activeElement).parents().hasClass('modal-dialog')) {
            attachEventHandler("modalOutsideClick", "backdropClick", true);
        }
        $(".body-wrapper").attr("aria-hidden", "false");
        for (var i = 0; i < $('.modal.fade').length; i++) {
            var ele = $('.modal.fade')[i];
            ele.setAttribute("aria-hidden", "false");
        }
        setTimeout(function () { focusElement.focus(); }, 1000);
        var iframeSrc = $(e.target).siblings();
        var iframeEle = $(iframeSrc).children('iframe');
        if ($(iframeEle).attr('allow') === 'autoplay') {
            $(iframeEle).attr('src', '');
        } else {
            $(iframeEle).attr('src', $(iframeSrc).children('iframe').attr('src'));
        }
    }


    function ensureModalIsFormChild(modal) {
        if (!modal.parent().is('body')) modal.appendTo('body');
    }

}(window.jQuery));
  
  /*Analytics*/
analytics.eventConfig.push({
  "target": ".homeHero", //heroBanner
  "events": [
      {
          "eventTarget": ".homeHero--itemCta", //tab navigation - move between slides
          "eventType": "click",
          "tags": {
            "heroBannerInteraction": "heroBannerInteraction",
            "interactionType": "Hit Tab",
            "heroBanner": {
              "name": "homeHero",
              "tab": "",
              "index": "",
            },
          }
      },
      {
        "eventTarget": ".homeHero--ctaContainer .cta-button a.button-primary", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "Click",
          "elementClicked": "button",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },
      {
        "eventTarget": ".homeHero--ctaContainer .cta-button a.button-secondary", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "Click",
          "elementClicked": "button",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },
      {
        "eventTarget": ".homeHero--ctaContainer .cta-button a.button-secondary-white", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "Click",
          "elementClicked": "button",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },{
        "eventTarget": ".homeHero--ctaContainer .cta-button-popup-modal a.button-primary", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "Click",
          "elementClicked": "button",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },
      {
        "eventTarget": ".homeHero--ctaContainer .cta-button-popup-modal a.button-secondary", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "Click",
          "elementClicked": "button",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },
      {
        "eventTarget": ".homeHero--ctaContainer .cta-button-popup-modal a.button-secondary-white", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "Click",
          "elementClicked": "button",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },
      {
        "eventTarget": ".homeHero--ctaContainer a.button-tertiary--white", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "Click",
          "elementClicked": "link",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },
      {
        "eventTarget": ".homeHero--ctaContainer a.button-tertiary", //click on banner CTA button
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "elementClicked": "link",
          "interactionType": "Click",
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
            "ctaText": "",
            "destinationURL": "",
          }
        }
      },
      {
        "eventTarget": ".homeHero--playBtn", //play pause interaction
        "eventType": "click",
        "tags": {
          "heroBannerInteraction": "heroBannerInteraction",
          "interactionType": "", //Play / Pause
          "heroBanner": {
            "name": "homeHero",
            "title": "",
            "index": "",
          }
        }
      }
  ]
}, 
);